import OrganisationDetailsPage from './orgnisationDetails/Details';

export default OrganisationDetailsPage;